import { Pagination } from "@mui/material";
import PropsElements from "Interfaces/PropsElements";
import styled from "styled-components";


export const TableReq = styled.table<any>`
  //margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 0px;
  font-size: 0.9rem;

  thead {
    tr {
      th {
        border-bottom: 2px solid ${({theme}) => theme.primary};
        border-collapse: separate;
        padding-left: 10px;
        padding-right: 10px;
      }
    }
  }

  tbody {
    tr {
      &:nth-child(2n) {
        background-color: ${({theme}) => theme.primary};
        color: #ffffff;
      }
      td {
        border-bottom: 1px solid #ffffff;
        border-collapse: separate;
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        height: 40px;
        white-space: nowrap !important;
        overflow: hidden !important;
        max-width: 350px !important;
        text-overflow: ellipsis !important;
      }
    }
  }
`;

export const TableMobile = styled.div`
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
`;

export const SimpleTable = styled.table`
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 0px;
  font-size: 0.9rem;

  thead {
    tr {
      th {
        border-bottom: 2px solid #00b3b0;
        border-collapse: separate;
      }
    }
  }

  tbody {
    tr {
      td {
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        height: 40px;
      }
    }
  }
`;

export const SimpleTableV2 = styled.table`
  margin-top: 30px;
  margin-bottom: 20px;
  width: 100%;
  border-collapse: separate;
  border-spacing: 0px 0px;
  font-size: 0.9rem;
  color: #fff;

  tbody {
    tr {
      td {
        padding-left: 10px;
        padding-right: 10px;
        text-align: center;
        height: 40px;
      }
    }
  }
`;

export const TableContainer = styled.div`
  /* margin: 20px; */
  width: 100%;
  //background: #FAFAFA 0% 0% no-repeat padding-box;
  opacity: 1;
  overflow-x: scroll;
`;

export const PaginationStyled = styled(Pagination)`
  width: 100%;
  text-align: center;
`;

export const ContainerTables = styled.div`
  display: block;
  overflow-x: auto;
  white-space: nowrap;

  @media screen and (max-width: 700px) {
    ${TableReq} {
      display: none;
    }
  }
  @media screen and (min-width: 701px) {
    ${TableMobile} {
      display: none;
    }
  }
`;

export const ItemContainer = styled.div<any>`
  display: flex;
  flex-direction: ${(props: PropsElements) =>
    props.column ? "column" : "row"};
  justify-content: flex-start;
  margin: 10px 0px;
  margin-left: 0;
  font-size: 0.9rem;
`;
export const LabelItem = styled.div`
  white-space: nowrap;
  font-weight: 600;
  margin-right: 10px;
`;
export const ValueItem = styled.div<any>`
  white-space: ${(props: PropsElements) => (props.wrap ? "normal" : "nowrap")};
`;
